import React from 'react';

export const Shield = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 3.00024C3 12.9999 3 19 12 23C21 19.0005 21 12.9999 21 3.00024H20.9988C19.6856 3.00011 14.9991 2.99962 12 1C9.00183 2.99902 3.9319 3.00005 3.0017 3.00024H3Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 11L12 14L16.5 9"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
